export default __webpack_public_path__ + "static/media/l22-dropdown.ded5f200.webp";